"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[51642],{

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 10699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconSettingSupport; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function IconSettingSupport() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_652_347)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M4.36833 7.25001C4.65417 4.94584 6.62 3.16667 9 3.16667C10.2892 3.16667 11.4558 3.69167 12.3017 4.53167C13.0133 5.24917 13.4975 6.19417 13.6317 7.25001",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.1667 13.515C11.6051 13.1464 12.7785 12.1085 13.3281 10.7522",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3.75 7.25H4.91667V10.75H3.75C3.10834 10.75 2.58334 10.225 2.58334 9.58333V8.41667C2.58334 7.775 3.10834 7.25 3.75 7.25Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M14.25 10.75H13.0833V7.25H14.25C14.8917 7.25 15.4167 7.775 15.4167 8.41667V9.58333C15.4167 10.225 14.8917 10.75 14.25 10.75Z",
                        stroke: "currentColor",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M8.125 13.3917H9.875C10.0269 13.3917 10.15 13.5148 10.15 13.6667C10.15 13.8185 10.0269 13.9417 9.875 13.9417H8.125C7.97312 13.9417 7.85 13.8185 7.85 13.6667C7.85 13.5148 7.97312 13.3917 8.125 13.3917Z",
                        fill: "#333333",
                        stroke: "currentColor",
                        strokeWidth: "1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_652_347",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 53887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Portfolio_PortoDetailModal; }
});

// UNUSED EXPORTS: PortoDetailModal

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var types = __webpack_require__(20620);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts + 1 modules
var usePortfolioDetailStore = __webpack_require__(98976);
// EXTERNAL MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts + 1 modules
var useEmittenInfoStore = __webpack_require__(97454);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
// EXTERNAL MODULE: ./src/global/GlobalModalManager/stores/useGlobalModalStore.ts
var useGlobalModalStore = __webpack_require__(14467);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPortfolioStore.ts
var useBondPortfolioStore = __webpack_require__(29176);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore.ts
var useBondsModalStore = __webpack_require__(81557);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics.ts
var useBondsAnalytics = __webpack_require__(29735);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/styled.ts
var styled = __webpack_require__(70098);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/features/securities/withdrawal/utils.ts
var utils = __webpack_require__(17921);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/InfoSvg.tsx
var InfoSvg = __webpack_require__(42958);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondInfoModal.ts
var useBondInfoModal = __webpack_require__(32471);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondCouponReceipt/components/Summary.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin: 8px 0px;\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            height: 40px;\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












function Summary(param) {
    var _total = param.total, total = _total === void 0 ? 0 : _total, _accruedInterest = param.accruedInterest, accruedInterest = _accruedInterest === void 0 ? 0 : _accruedInterest, _sellerCoupon = param.sellerCoupon, sellerCoupon = _sellerCoupon === void 0 ? 0 : _sellerCoupon;
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* BorderedContainer */.a$, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                direction: "column",
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: "#858585",
                        size: "12px",
                        children: [
                            "Total Penerimaan Kupon",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: color/* default.primary */.Z.primary,
                        size: "20px",
                        family: "bold",
                        children: (0,utils/* formatBondCurrency */.uJ)(total)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        align: "center",
                        justify: "center",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "#858585",
                                size: "12px",
                                children: [
                                    "Total Kupon Hak Kamu",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            color: "#969696"
                                        },
                                        onClick: function() {
                                            return openInfoModal(constants/* BondInfoType.USER_COUPON */.Im.USER_COUPON);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "14px",
                                family: "bold",
                                children: (0,utils/* formatBondCurrency */.uJ)(accruedInterest)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledDivider2, {
                        type: "vertical"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        align: "center",
                        justify: "center",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "#858585",
                                size: "12px",
                                children: [
                                    "Total Kupon Penjual",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            color: "#969696"
                                        },
                                        onClick: function() {
                                            return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                size: "14px",
                                family: "bold",
                                children: (0,utils/* formatBondCurrency */.uJ)(sellerCoupon)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var _StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-2d17917e-0"
})(_templateObject());
var _StyledDivider2 = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-2d17917e-1"
})(_templateObject1());

// EXTERNAL MODULE: ./src/global/Collapsible/index.tsx + 1 modules
var Collapsible = __webpack_require__(80557);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondCouponReceipt/components/HistoryRowItem.tsx





function HistoryRowItem(param) {
    var date = param.date, amount = param.amount, accruedInterest = param.accruedInterest, sellerCoupon = param.sellerCoupon;
    var headerElement = // @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        p: "8px 0px",
        justify: "space-between",
        align: "center",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "14px",
                children: (0,utils/* formatBondDate */.qF)(new Date(date))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                size: "14px",
                children: (0,utils/* formatBondCurrency */.uJ)(amount)
            })
        ]
    });
    if (sellerCoupon <= 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: headerElement
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* default */.Z, {
        header: headerElement,
        expandDirection: "bottom",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "center",
                width: "100%",
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#858585",
                        size: "14px",
                        children: "Kupon Hak Kamu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#858585",
                        size: "14px",
                        children: (0,utils/* formatBondCurrency */.uJ)(accruedInterest)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#858585",
                        size: "14px",
                        children: "Kupon Penjual"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#858585",
                        size: "14px",
                        children: (0,utils/* formatBondCurrency */.uJ)(sellerCoupon)
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondCouponReceipt/components/HistoryRowGroup.tsx




function HistroyRowGroup(param) {
    var history = param.history;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* HistoryGroupContainer */.w2, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                color: "#858585",
                children: [
                    "Kupon ",
                    history.year
                ]
            }),
            history.items.map(function(item) {
                var ref, ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(HistoryRowItem, {
                    date: item.date,
                    amount: item.amount,
                    accruedInterest: (ref = item.coupon) === null || ref === void 0 ? void 0 : ref.user,
                    sellerCoupon: (ref1 = item.coupon) === null || ref1 === void 0 ? void 0 : ref1.seller
                });
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondCouponReceipt/index.tsx


function ModalBondCouponReceipt_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: 500px;\n          "
    ]);
    ModalBondCouponReceipt_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function ModalBondCouponReceipt(param) {
    var isVisible = param.isVisible, onCancel = param.onCancel;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return [
            s.couponHistories
        ];
    }), 1), couponHistories = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalRoot */.Y0, {
        visible: isVisible,
        onCancel: onCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalContainer */.F0, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalHeader */.xB, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "between",
                        align: "center",
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                size: "18px",
                                align: "center",
                                // @ts-expect-error
                                mt: "0",
                                width: "100%",
                                "data-cy": "bonds-modal-header",
                                children: "Riwayat Penerimaan Kupon"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                className: "icon-trading_x",
                                color: "#333333",
                                size: "12px",
                                onClick: onCancel
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(_StyledModalBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary, {
                            total: couponHistories === null || couponHistories === void 0 ? void 0 : couponHistories.total,
                            accruedInterest: couponHistories.total_user_coupon,
                            sellerCoupon: couponHistories.total_seller_coupon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CouponHistoryContainer */.CQ, {
                            children: couponHistories === null || couponHistories === void 0 ? void 0 : (ref = couponHistories.histories) === null || ref === void 0 ? void 0 : ref.map(function(history) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistroyRowGroup, {
                                    history: history
                                }, "coupon-history-".concat(history.year));
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var _StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(styled/* ModalBody */.fe).withConfig({
    componentId: "sc-ef96e64c-0"
})(ModalBondCouponReceipt_templateObject());

// EXTERNAL MODULE: ./src/features/transaction/provider.tsx + 1 modules
var provider = __webpack_require__(207);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 1 modules
var BaseSecuritiesModal = __webpack_require__(48871);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var lib_useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(66350);
// EXTERNAL MODULE: ./src/global/Securities/api/termsAndConditions.ts
var termsAndConditions = __webpack_require__(95248);
;// CONCATENATED MODULE: ./src/global/Securities/api/useTermAndConditionsAPI.ts





var useGetTncByFeatures = function(featureIds) {
    var query = (0,lib_useQuery/* useQuery */.a)({
        queryKey: [
            "tnc-features",
            featureIds
        ],
        queryFn: (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,termsAndConditions/* getTnCByFeatures */.vj)(featureIds);
                    case 2:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onError: function(error) {
            (0,errors/* errorHandler */.P)(error, "Failed to load TnC features");
        },
        cacheTime: 1 * 60 * 1000
    });
    return query;
};
var useAcceptTnc = function() {
    var mutation = (0,useMutation/* useMutation */.D)({
        mutationFn: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,termsAndConditions/* postTnCAcceptances */.qo)(payload);
                        case 2:
                            return _ctx.abrupt("return", _ctx.sent.data);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            (0,errors/* errorHandler */.P)(error, "Failed to accept TnC");
            return undefined;
        },
        retry: false
    });
    return mutation;
};

// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/AutoOrderTnc.styled.ts

function AutoOrderTnc_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 20px 20px;\n  box-sizing: border-box;\n"
    ]);
    AutoOrderTnc_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AutoOrderTnc_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 40px;\n  gap: 8px;\n"
    ]);
    AutoOrderTnc_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  height: 500px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.9);\n  z-index: 10;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n  max-height: 500px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  cursor: pointer;\n\n  span {\n    color: #00ab6b;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 16px 0 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n\n  &:disabled {\n    background-color: #cceee1 !important;\n    color: #ffffff !important;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35a73497-0"
})(AutoOrderTnc_styled_templateObject());
var AgreementWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35a73497-1"
})(AutoOrderTnc_styled_templateObject1());
var AgreementLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-35a73497-2"
})(_templateObject2());
var TnCWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35a73497-3"
})(_templateObject3());
var TnCLoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35a73497-4"
})(_templateObject4());
var TnCFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-35a73497-5"
})(_templateObject5());
var AgreementTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35a73497-6"
})(_templateObject6());
var ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35a73497-7"
})(_templateObject7());
var NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-35a73497-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/AutoOrderTnc.tsx
















function AutoOrderTnc(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)(false), tncAgreed = ref1[0], setTncAgreed = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(true), iframeLoading = ref3[0], setIframeLoading = ref3[1];
    var ref4 = useGetTncByFeatures([
        termsAndCondition/* TnCFeaturesIDEnum.AUTO_ORDER */.el.AUTO_ORDER
    ]), data = ref4.data, refetch = ref4.refetch;
    var mutationFn = useAcceptTnc();
    var ref5;
    var ref6 = (0,_sliced_to_array/* default */.Z)((ref5 = data === null || data === void 0 ? void 0 : data.acceptance_letters) !== null && ref5 !== void 0 ? ref5 : [
        {}
    ], 1), ref7 = ref6[0], featureId = ref7.feature_id, TncVersion = ref7.version, url = ref7.url;
    var handleCancel = function(e) {
        onCancel(e);
    };
    var handleCheckboxChange = function(event) {
        setTncAgreed(event.target.checked);
    };
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var payload;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (TncVersion) {
                            setLoading(true);
                            payload = {
                                feature_id: String(featureId),
                                version: TncVersion,
                                is_accepted: tncAgreed
                            };
                            mutationFn.mutateAsync([
                                payload
                            ], {
                                onSuccess: function(res) {
                                    if (res) {
                                        setTncAgreed(true);
                                        onSubmit();
                                        refetch();
                                    }
                                }
                            });
                            setLoading(false);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Syarat & Ketentuan Auto Order",
        onCancel: handleCancel,
        className: "modal-tnc-auto-order",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TnCWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                condition: iframeLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCLoadingWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
                                        style: {
                                            color: "#00AB6B",
                                            fontSize: "20px"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                condition: !!url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                                    title: "auto-order-tnc",
                                    src: url,
                                    id: "auto-order-tnc",
                                    onLoad: function() {
                                        return setIframeLoading(false);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreementWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    checked: tncAgreed,
                                    onChange: handleCheckboxChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreementTextWrapper, {
                                    onClick: function() {
                                        return setTncAgreed(!tncAgreed);
                                    },
                                    children: [
                                        "Saya menyetujui Syarat & Ketentuan Penggunaan",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Auto Order"
                                        }),
                                        " di atas."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                                onClick: handleSubmit,
                                type: "primary",
                                disabled: !tncAgreed || loading,
                                loading: loading,
                                children: "Lanjut"
                            })
                        })
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./src/features/trade/components/AutoOrder/index.tsx + 3 modules
var AutoOrder = __webpack_require__(19382);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/index.tsx + 3 modules
var DetailModal = __webpack_require__(4303);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/global/Securities/types/api/history.ts
var TransactionPeriod;
(function(TransactionPeriod) {
    TransactionPeriod["All"] = "all";
    TransactionPeriod["OneMonth"] = "1 month";
    TransactionPeriod["ThreeMonths"] = "3 month";
    TransactionPeriod["OneYear"] = "1 year";
})(TransactionPeriod || (TransactionPeriod = {}));

// EXTERNAL MODULE: ./src/features/trade/components/History/styled.ts
var History_styled = __webpack_require__(67744);
// EXTERNAL MODULE: ./src/features/trade/components/History/EmptyState.tsx
var EmptyState = __webpack_require__(74551);
// EXTERNAL MODULE: ./src/features/trade/components/History/HistoryModal.tsx + 2 modules
var HistoryModal = __webpack_require__(47439);
// EXTERNAL MODULE: ./src/features/trade/components/History/HistoryTableData.tsx
var HistoryTableData = __webpack_require__(11481);
// EXTERNAL MODULE: ./src/features/trade/components/History/utils.js
var History_utils = __webpack_require__(36675);
// EXTERNAL MODULE: ./src/features/trade/components/ShimmerTable.tsx
var ShimmerTable = __webpack_require__(3194);
;// CONCATENATED MODULE: ./src/features/trade/components/History/SymbolHistoryModal/constants.ts

var PERIOD_SELECTIONS = [
    {
        value: TransactionPeriod.OneMonth,
        label: "Last 1 Month"
    },
    {
        value: TransactionPeriod.ThreeMonths,
        label: "Last 3 Months"
    },
    {
        value: TransactionPeriod.OneYear,
        label: "Last 1 Year"
    }, 
];

;// CONCATENATED MODULE: ./src/features/trade/components/History/SymbolHistoryModal/PeriodSelection.tsx





function PeriodSelection(param) {
    var popUpId = param.popUpId, period = param.period, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(History_styled/* Select */.Ph, {
            // @ts-expect-error
            height: "28px",
            defaultValue: period,
            value: period,
            onChange: onChange,
            getPopupContainer: function() {
                return document.getElementById(popUpId);
            },
            children: PERIOD_SELECTIONS.map(function(param) {
                var label = param.label, value = param.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(History_styled/* Select.Option */.Ph.Option, {
                    value: value,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: period === value ? color/* default.primary */.Z.primary : color/* default.nightRider */.Z.nightRider,
                        family: period === value ? "bold" : "regular",
                        as: "span",
                        className: period === value ? "select-label" : "",
                        children: label
                    })
                }, value);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/trade/components/History/SymbolHistoryModal/index.tsx


















var SymbolHistoryModal = function(param) {
    var onCancel = param.onCancel, symbol = param.symbol, visible = param.visible, stockType = param.stockType;
    var ref = (0,tradingData/* default */.Z)(), setSkeleton = ref.setSkeleton, getTransactionHistory = ref.getTransactionHistory, _transactionHistory = ref.transactionHistory, showSkeleton = _transactionHistory.showSkeleton, data = _transactionHistory.data;
    var ref1 = (0,react.useState)(null), currentRecord = ref1[0], setCurrentRecord = ref1[1];
    var ref2 = (0,react.useState)(showSkeleton), shimmer = ref2[0], showShimmer = ref2[1];
    var ref3 = (0,react.useState)(TransactionPeriod.OneMonth), period = ref3[0], setPeriod = ref3[1];
    // Merging the Records
    var displayedData = (0,react.useMemo)(function() {
        return data === null || data === void 0 ? void 0 : data.history.map(function(history) {
            return history.history_list;
        }).reduce(function(prev, curr) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(curr));
        }, []);
    }, [
        data,
        symbol,
        period
    ]);
    var handleFilterChanged = (0,react.useCallback)(lodash_debounce_default()(function(filters) {
        getTransactionHistory(filters);
    }, 200), []);
    var handleHistoryModalCancel = function() {
        setCurrentRecord(null);
    };
    var handlePeriodChanged = function(selectedPeriod) {
        setPeriod(selectedPeriod);
    };
    var getRowClassName = function(record) {
        if (record.groupDate) return "group-date-row";
        return "";
    };
    var handleRecordClick = function(record) {
        return {
            onClick: function() {
                if (record) {
                    setCurrentRecord(record);
                }
            }
        };
    };
    var middleColumns = stockType === "bond" ? HistoryTableData/* middleColumnsBonds */.TF : HistoryTableData/* middleColumns */.IA;
    var columns = [
        {
            key: "display_as",
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodSelection, {
                onChange: handlePeriodChanged,
                period: period,
                popUpId: "history-modal-select-container"
            }),
            dataIndex: "display_as",
            className: "td-mobile history-order-item",
            width: "13%",
            render: function(text, dataObject) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: dataObject.status_color_code,
                            as: "span",
                            family: stockType === "bond" ? "" : "bold",
                            children: text
                        }),
                        dataObject.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(History_styled/* SellBadge */.tY, {
                            family: "bold",
                            children: dataObject.label.toUpperCase()
                        })
                    ]
                });
            }
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(middleColumns), [
        {
            key: "date",
            title: "Date",
            dataIndex: "date",
            className: "td-mobile history-date normal",
            width: "15%",
            render: function(text, dataObject) {
                return (0,History_utils/* renderTableRowContent */.YK)(text, dataObject, /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    align: "right",
                    family: "bold",
                    children: (0,History_utils/* formatDate */.p6)(text)
                }));
            }
        }, 
    ]);
    var shimmerColumns = [
        {
            key: "display_as",
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(PeriodSelection, {
                onChange: handlePeriodChanged,
                period: period,
                popUpId: "history-modal-select-container"
            }),
            dataIndex: "display_as",
            className: "td-mobile history-order-item",
            width: "13%",
            render: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                    paragraph: false,
                    title: {
                        style: {
                            margin: "auto"
                        }
                    },
                    loading: true,
                    active: true
                });
            }
        }, 
    ];
    (0,react.useEffect)(function() {
        showShimmer(true);
        handleFilterChanged({
            period: period,
            keyword: symbol
        }, false);
    }, [
        symbol,
        period
    ]);
    (0,react.useEffect)(function() {
        showShimmer(showSkeleton);
    }, [
        showSkeleton
    ]);
    (0,react.useEffect)(function() {
        return function() {
            setSkeleton("transactionHistory", true);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryModal/* HistoryModal */.u, {
                visible: Boolean(currentRecord),
                onCancel: handleHistoryModalCancel,
                onCompanyClick: handleHistoryModalCancel,
                record: currentRecord
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !currentRecord,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    visible: visible,
                    onCancel: onCancel,
                    centered: true,
                    width: 1000,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            padding: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                align: "center",
                                family: "bold",
                                size: "18px",
                                children: "Riwayat Transaksi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(History_styled/* SelectContainer */.eI, {
                                id: "history-modal-select-container"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(History_styled/* HistoryTable */.uW, {
                                style: {
                                    height: 400
                                },
                                scroll: {
                                    y: 340
                                },
                                dataSource: shimmer ? ShimmerTable/* shimmerTableData */.B : displayedData,
                                columns: shimmer ? shimmerColumns : columns,
                                pagination: false,
                                locale: {
                                    emptyText: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* EmptyStateInModal */.pz, {})
                                },
                                rowClassName: getRowClassName,
                                onRow: handleRecordClick
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var History_SymbolHistoryModal = (SymbolHistoryModal);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/global/Securities/hooks/useLivePriceUpdater.ts
var useLivePriceUpdater = __webpack_require__(76870);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts + 1 modules
var useIsUserSyariah = __webpack_require__(66940);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var formula = __webpack_require__(98202);
// EXTERNAL MODULE: ./src/global/Securities/types/stockType.ts
var types_stockType = __webpack_require__(56644);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Securities/components/SkeletonWrapper/index.tsx
var SkeletonWrapper = __webpack_require__(27607);
// EXTERNAL MODULE: ./src/features/syariah/components/NonSyariahBanner.tsx
var NonSyariahBanner = __webpack_require__(22067);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/InfoTable.tsx
var InfoTable = __webpack_require__(51981);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/features/trade/components/Portfolio/styled.ts
var Portfolio_styled = __webpack_require__(62469);
;// CONCATENATED MODULE: ./src/features/trade/components/Portfolio/ToHistoryButton.tsx








var ToHistoryButton = function(param) {
    var symbol = param.symbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/securities/history?symbol=".concat(symbol, "&period=all"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* SectionButton */.M9, {
            "data-cy": "transaction-history-button",
            className: "button-unstyled full-button",
            type: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                dataSource: [
                    {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            children: "Riwayat Transaksi"
                        }),
                        value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            align: "center",
                            style: {
                                gap: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    color: color/* default.primary */.Z.primary,
                                    children: "See All"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    className: "icon-trading_back reverse"
                                })
                            ]
                        })
                    }, 
                ]
            })
        })
    });
};
/* harmony default export */ var Portfolio_ToHistoryButton = (ToHistoryButton);

// EXTERNAL MODULE: ./node_modules/antd/es/progress/index.js + 9 modules
var progress = __webpack_require__(58008);
;// CONCATENATED MODULE: ./src/features/trade/components/Portfolio/PortfolioAllocation.tsx







var PortfolioAllocation = function(param) {
    var equity = param.equity, unrealisedMarketValue = param.unrealisedMarketValue;
    var allocationPercentage = (0,react.useMemo)(function() {
        return unrealisedMarketValue / equity * 100;
    }, [
        unrealisedMarketValue,
        equity
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
        dataSource: [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: "Portfolio Allocation"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    as: "p",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(progress/* default */.Z, {
                            width: 20,
                            strokeWidth: 16,
                            trailColor: "#EDEDED",
                            percent: allocationPercentage,
                            type: "circle",
                            showInfo: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ml: "5px",
                            family: "bold",
                            children: (0,number/* formatPercentage */.rl)(allocationPercentage, true, "0.00", true)
                        })
                    ]
                })
            }, 
        ]
    });
};
/* harmony default export */ var Portfolio_PortfolioAllocation = (PortfolioAllocation);

// EXTERNAL MODULE: ./src/global/Securities/types/store/order.ts
var order = __webpack_require__(91037);
// EXTERNAL MODULE: ./src/features/day-trade/components/Badge.tsx
var Badge = __webpack_require__(21548);
// EXTERNAL MODULE: ./src/features/syariah/components/NonSyariahBadge.tsx
var NonSyariahBadge = __webpack_require__(11322);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
;// CONCATENATED MODULE: ./src/lib/queries/trade.ts




var useGetOrderList = function() {
    var gtc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, stock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0,lib_useQuery/* useQuery */.a)({
        queryKey: [
            "orderList",
            stock
        ],
        queryFn: (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return trade/* default.getOrderList */.Z.getOrderList(gtc, stock);
                    case 2:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onError: function() {
            return [];
        }
    });
};
var useGetOrderHistory = function(params) {
    return useQuery({
        queryKey: [
            "orderHistory",
            params
        ],
        queryFn: _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var response;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return tradeAPI.getHistory(params);
                    case 2:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        onError: function() {
            return [];
        }
    });
};

// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderDetailStore.ts
var useOrderDetailStore = __webpack_require__(87127);
// EXTERNAL MODULE: ./src/global/Securities/types/api/orderList.ts
var orderList = __webpack_require__(75626);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var types_trading = __webpack_require__(6421);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/styled.ts
var OrderTable_styled = __webpack_require__(56416);
;// CONCATENATED MODULE: ./src/features/trade/components/Portfolio/OrderList.tsx





















var mapSmartOrderLabel = function(label) {
    if (label === types_trading/* SmartOrderLabel.BO */.D0.BO) return "SL/TP";
    if (label === types_trading/* SmartOrderLabel.LIT_SELL */.D0.LIT_SELL || label === types_trading/* SmartOrderLabel.AB */.D0.AB) {
        return "LIT";
    }
    return label;
};
var Order = function(param) {
    var item = param.item, onClick = param.onClick;
    var isSyariahUser = (0,useIsUserSyariah/* default */.Z)();
    var isBondOrder = item.securities_kind === order/* OrderSecuritiesKindType.Bond */.IC.Bond;
    var isMarketOrder = item.platform_order_type === order/* PlatformOrderTypes.FAK */.F4.FAK;
    var amount = function() {
        if (isBondOrder) return "-";
        if (item.trailing_stop) {
            return (0,number/* formatNumber */.uf)(item.amount_invested, true, "0,0");
        }
        if (isMarketOrder) {
            if ([
                transaction/* OrderStatus.Rejected */.iF.Rejected,
                transaction/* OrderStatus.Pending */.iF.Pending,
                transaction/* OrderStatus.Open */.iF.Open,
                transaction/* OrderStatus.Amended */.iF.Amended, 
            ].includes(item.status)) {
                return "-";
            }
            if (item.status === transaction/* OrderStatus.Withdrawn */.iF.Withdrawn) {
                return (0,number/* formatNumber */.uf)(item.amount_invested + item.amount_fee, true, "0,0");
            }
        }
        return (0,number/* formatNumber */.uf)(item.amount_invested_fee, true, "0,0");
    }();
    var price = function() {
        if (item.securities_kind === order/* OrderSecuritiesKindType.Bond */.IC.Bond) {
            return (0,number/* formatPercentage */.rl)(item.price);
        }
        if (item.price_order) return (0,number/* formatNumber */.uf)(item.price, true, "0,0");
        return "-";
    }();
    var gtc = function() {
        if (isBondOrder) {
            return "-";
        }
        if (isMarketOrder) return "FAK";
        return item.gtc ? "GTC" : "DAY";
    }();
    var getStatusText = function() {
        if (item.status === transaction/* OrderStatus.Succeed */.iF.Succeed) return "Success";
        return item.status;
    };
    var statusText = getStatusText();
    var getOrderStatusClass = function(status) {
        if (status === transaction/* OrderStatus.RequestAmend */.iF.RequestAmend) return "request_amend";
        return status.toLowerCase();
    };
    var statusClass = getOrderStatusClass(statusText);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Portfolio_styled/* OrderRow */.yu, {
        onClick: function() {
            return onClick(item);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                width: "114px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Portfolio_styled/* CustomText */.DX, {
                        className: "action-content ".concat(item.action === orderList/* OrderAction.Buy */.i.Buy ? "buy" : "sell"),
                        children: [
                            item.action,
                            " ",
                            item.symbol.toUpperCase()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: Boolean(item.label && item.label !== "MO"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTable_styled/* AutoOrderBadge */.NR, {
                            children: mapSmartOrderLabel(item.label)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: item.day_trade_is_day_trade,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                            label: item.day_trade_force_sell_event
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isSyariahUser && item.is_sharia === false && !isBondOrder,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NonSyariahBadge/* default */.Z, {
                            label: "Non-Syariah"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                width: "114px",
                align: "right",
                size: "12px",
                children: amount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                width: "44px",
                align: "right",
                size: "12px",
                children: price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                width: "44px",
                align: "right",
                size: "12px",
                children: gtc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 84
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* CustomText */.DX, {
                    className: (0,clsx_m/* default */.Z)([
                        statusClass
                    ]),
                    children: statusText
                })
            })
        ]
    });
};
var OrderList = function(param) {
    var symbol = param.symbol, isDayTrade = param.isDayTrade;
    var ref = (0,react.useState)([]), orders = ref[0], setOrders = ref[1];
    var data = useGetOrderList(0, symbol).data;
    var loadDetail = (0,useOrderDetailStore/* default */.Z)(function(s) {
        return s.loadOrderDetail;
    });
    var openBondOrderModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openOrderModal;
    });
    (0,react.useEffect)(function() {
        if (data && data.length > 0) {
            var newOrders = data.filter(function(d) {
                return isDayTrade ? d.day_trade.is_day_trade : !d.day_trade.is_day_trade;
            }).map(function(d) {
                return transformData/* default.orderDetail */.Z.orderDetail(d);
            });
            setOrders(newOrders);
        }
        // subscribe to ws change
        tradingData/* default.subscribe */.Z.subscribe(function(s) {
            return s.orderHistory.data;
        }, function(orderHistory) {
            var symbolOrderHistory = orderHistory.filter(function(item) {
                return item.symbol === symbol && isDayTrade ? item.day_trade_is_day_trade : !item.day_trade_is_day_trade;
            });
            setOrders(symbolOrderHistory);
        });
    }, [
        data
    ]);
    var handleRow = function(item) {
        if (item.securities_kind === order/* OrderSecuritiesKindType.Bond */.IC.Bond) {
            openBondOrderModal(item.orderid);
            return;
        }
        loadDetail(item.orderid);
    };
    if (orders.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Portfolio_styled/* TableContent */.gO, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                padding: "18px 16px",
                size: 12,
                weight: 700,
                children: "Order List"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* TableHeader */.xD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    height: "32px",
                    align: "center",
                    padding: "0 16px",
                    style: {
                        gap: 16
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "114px",
                            size: "12px",
                            children: "Action"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "114px",
                            align: "right",
                            size: "12px",
                            children: "Amount"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "44px",
                            align: "right",
                            size: "12px",
                            children: "Price"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "44px",
                            align: "right",
                            size: "12px",
                            children: "Expiry"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "84px",
                            size: "12px",
                            children: "Status"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* OrdersTable */.m8, {
                children: orders.map(function(order) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Order, {
                        item: order,
                        onClick: handleRow
                    }, order.orderid);
                })
            })
        ]
    });
};
/* harmony default export */ var Portfolio_OrderList = (OrderList);

;// CONCATENATED MODULE: ./src/features/trade/components/Portfolio/ModalDetail.tsx













// Store





// Utils




// Constants



// Component











var MODAL_TYPES = {
    detail: "detail",
    exercise: trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE,
    sell: trading/* ORDER_TYPE.SELL */.Jm.SELL,
    history: "history",
    tnc: types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC,
    autoorder: "auto-order"
};
var ModalDetail = function(param) {
    var symbol = param.symbol, stockType = param.stockType, _isDayTrade = param.isDayTrade, isDayTrade = _isDayTrade === void 0 ? false : _isDayTrade, _onAutoOrderClick = param.onAutoOrderClick, onAutoOrderClick = _onAutoOrderClick === void 0 ? function() {} : _onAutoOrderClick;
    var ref = (0,tradingData/* default */.Z)(function(s) {
        var ref, ref1;
        return {
            portfolioData: s.portfolio.data,
            exerciseType: (ref1 = (ref = s.portfolio.data.result) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                return item.symbol === symbol;
            })) === null || ref1 === void 0 ? void 0 : ref1.exercise_type,
            configFormula: s.configFormula.data
        };
    }, shallow/* default */.Z), portfolioData = ref.portfolioData, exerciseType = ref.exerciseType, configFormula = ref.configFormula;
    var ref1 = (0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return {
            portfolioDetail: s.data,
            portfolioDetailDayTrade: s.dayTrade,
            isPortfolioDetailLoading: s.isLoading,
            updatePortfolioDetail: s.updatePortfolioDetail
        };
    }, shallow/* default */.Z), portfolioDetail = ref1.portfolioDetail, portfolioDetailDayTrade = ref1.portfolioDetailDayTrade, isPortfolioDetailLoading = ref1.isPortfolioDetailLoading, updatePortfolioDetail = ref1.updatePortfolioDetail;
    var ref2 = useGetTncByFeatures([
        termsAndCondition/* TnCFeaturesIDEnum.AUTO_ORDER */.el.AUTO_ORDER, 
    ]), data = ref2.data, isSuccess = ref2.isSuccess;
    var ref3;
    var ref4 = (0,_sliced_to_array/* default */.Z)((ref3 = data === null || data === void 0 ? void 0 : data.acceptance_letters) !== null && ref3 !== void 0 ? ref3 : [
        {}
    ], 1), ref5 = ref4[0], isTncAccepted = ref5.is_accepted;
    var isCompanyLoading = (0,useEmittenInfoStore/* default */.Z)(function(s) {
        return s.isLoading;
    });
    var isUserSyariah = (0,useIsUserSyariah/* default */.Z)();
    var selectedPortfolioDetail = isDayTrade ? portfolioDetailDayTrade : portfolioDetail;
    var ref6 = selectedPortfolioDetail || {}, exerciseData = ref6.exercise_data, balanceShare = ref6.balance_share, balanceLot = ref6.balance_lot, availableShare = ref6.available_share, availableLot = ref6.available_lot, stockOnHand = ref6.stock_on_hand, priceAverageFee = ref6.price_average_fee, priceLatest = ref6.price_latest, unrealisedMarketValue = ref6.unrealised_marketvalue, unrealisedProfitloss = ref6.unrealised_profitloss, unrealisedGain = ref6.unrealised_gain, showCreateSmartOrder = ref6.show_create_smartorder, total = ref6.total, isStockSyariah = ref6.is_sharia;
    var equity = portfolioData.equity;
    var isShowAutoOrder = (0,react.useMemo)(function() {
        return showCreateSmartOrder && stockType === types_stockType/* StockType.Saham */.Z.Saham && !isDayTrade;
    }, [
        showCreateSmartOrder,
        stockType,
        isDayTrade
    ]);
    var handleAutoOrderClick = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isAutoOrderAccepted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,autoOrder/* trackAutoSellOrderSelected */.bm)(symbol);
                        isAutoOrderAccepted = isTncAccepted && isSuccess;
                        onAutoOrderClick(isAutoOrderAccepted ? MODAL_TYPES.autoorder : MODAL_TYPES.tnc);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAutoOrderClick() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useLivePriceUpdater/* default */.Z)({
        symbol: symbol,
        page: "portfolio_detail"
    }, function(param) {
        var lastprice = param.lastprice;
        var updatedData = (0,formula/* generateUpdatedPortfolioItem */.jm)(configFormula, lastprice, balanceLot, total);
        updatePortfolioDetail((0,_object_spread/* default */.Z)({
            price_latest: lastprice
        }, updatedData), false, isDayTrade);
    });
    var portfolioDataSource = (0,react.useMemo)(function() {
        var isRightOrWarran = [
            types_stockType/* StockType.Waran */.Z.Waran,
            types_stockType/* StockType.Right */.Z.Right
        ].includes(stockType);
        return [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "balance-".concat(isRightOrWarran ? "share" : "lot", "-label"),
                    children: "Balance ".concat(isRightOrWarran ? "Shares" : "Lot")
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "balance-".concat(isRightOrWarran ? "share" : "lot", "-content"),
                    children: Number(isRightOrWarran ? balanceShare : balanceLot || 0)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "available-".concat(isRightOrWarran ? "share" : "lot", "-label"),
                    children: isRightOrWarran ? "Available Shares" : "Available Lot"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "available-".concat(isRightOrWarran ? "share" : "lot", "-content"),
                    children: Number(isRightOrWarran ? availableShare : availableLot || 0)
                })
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(isRightOrWarran ? [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "stock-on-hand-label",
                    children: "Stock on Hand"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "stock-on-hand-content",
                    children: Number(stockOnHand)
                })
            }, 
        ] : []), [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "average-price-label",
                    children: "Average Price"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "average-price-content",
                    children: (0,number/* formatNumber */.uf)(priceAverageFee, true, "0,0.00")
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "current-price-label",
                    children: "Current Price"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "current-price-content",
                    children: (0,number/* formatNumber */.uf)(priceLatest)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "invested-label",
                    children: "Invested"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "invested-content",
                    children: (0,number/* formatNumber */.uf)(total)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "market-value-label",
                    children: "Market Value"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "market-value-content",
                    children: (0,number/* formatNumber */.uf)(unrealisedMarketValue)
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "potential-pnl-label",
                    children: "Potential P&L"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        "data-cy": "potential-pnl-content",
                        color: (0,general/* getColorBasedOnNumber */.pV)(unrealisedProfitloss),
                        children: [
                            unrealisedProfitloss > 0 ? "+" : "",
                            (0,number/* formatNumber */.uf)(unrealisedProfitloss)
                        ]
                    })
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    "data-cy": "percentage-label",
                    children: "Percentage"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    "data-cy": "percentage-content",
                    color: (0,general/* getColorBasedOnNumber */.pV)(unrealisedGain),
                    children: [
                        unrealisedGain > 0 ? "+" : "",
                        (0,number/* formatPercentage */.rl)(unrealisedGain * 100, false, "0.00", true)
                    ]
                })
            }, 
        ]);
    }, [
        balanceShare,
        balanceLot,
        availableShare,
        availableLot,
        stockOnHand,
        priceAverageFee,
        priceLatest,
        total,
        unrealisedMarketValue,
        unrealisedProfitloss,
        unrealisedGain,
        stockType, 
    ]);
    var exerciseDataSource = (0,react.useMemo)(function() {
        if (!exerciseData) return [];
        return [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: "Exercise End"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: moment_default()(exerciseData.exercise_end_date, "DD-MM-YYYY").format("DD MMM YYYY")
                })
            },
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: "Exercise Price"
                }),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: exerciseData.price
                })
            }, 
        ];
    }, [
        exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.exercise_end_date,
        exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.price
    ]);
    var isAutoOrderVisible = (0,react.useMemo)(function() {
        if (isPortfolioDetailLoading || isCompanyLoading) {
            return exerciseType !== "Warran";
        }
        return isShowAutoOrder;
    }, [
        isPortfolioDetailLoading,
        isCompanyLoading,
        exerciseType,
        isShowAutoOrder, 
    ]);
    var showNonSyariahBanner = (0,react.useMemo)(function() {
        return isUserSyariah && !isStockSyariah;
    }, [
        isUserSyariah,
        isStockSyariah
    ]);
    var getStockType = function(stock) {
        switch(stock){
            case types_stockType/* StockType.Waran */.Z.Waran:
                return "Warrant";
            case types_stockType/* StockType.Right */.Z.Right:
                return "Right";
            default:
                return "Saham";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: exerciseType === "Warran" ? 299 : 268
                }),
                loading: isPortfolioDetailLoading || isCompanyLoading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showNonSyariahBanner,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NonSyariahBanner/* default */.Z, {
                            children: [
                                getStockType(stockType),
                                " telah keluar dari",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Daftar Efek Syariah."
                                }),
                                " Segera Jual saham tersebut dari portfolio kamu."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioInfoTable */.Tm, {
                        dataSource: portfolioDataSource
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: exerciseType,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                    skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                        height: 82
                    }),
                    loading: isPortfolioDetailLoading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: exerciseData,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                            dataSource: exerciseDataSource
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 56
                }),
                loading: isPortfolioDetailLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_PortfolioAllocation, {
                    unrealisedMarketValue: unrealisedMarketValue,
                    equity: equity
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isAutoOrderVisible,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                    skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                        height: 51
                    }),
                    loading: isPortfolioDetailLoading || isCompanyLoading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* SectionButton */.M9, {
                        "data-cy": "auto-order-button",
                        className: "button-unstyled full-button",
                        onClick: handleAutoOrderClick,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                            dataSource: [
                                {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        style: {
                                            gap: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                style: {
                                                    width: 16
                                                },
                                                src: "/icon/plus-circle.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: "bold",
                                                color: color/* default.primary */.Z.primary,
                                                children: "Auto Order"
                                            })
                                        ]
                                    }),
                                    value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                        className: "icon-trading_back reverse"
                                    })
                                }, 
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_OrderList, {
                symbol: symbol,
                isDayTrade: isDayTrade
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_ToHistoryButton, {
                symbol: symbol
            })
        ]
    });
};
/* harmony default export */ var Portfolio_ModalDetail = (ModalDetail);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/assets/customIcon/IconSettingSupport.tsx
var IconSettingSupport = __webpack_require__(10699);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
;// CONCATENATED MODULE: ./src/features/trade/components/Portfolio/ModalDetailStockBond.tsx





// Store



// Utils

// Component





var ModalDetailStockBond_ModalDetail = function(param) {
    var symbol = param.symbol;
    var ref, ref1, ref2;
    var portfolioData = (0,tradingData/* default */.Z)(function(s) {
        return {
            portfolioData: s.portfolio.data
        };
    }).portfolioData;
    var ref3 = (0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return {
            selectedPortfolioDetail: s.data,
            isPortfolioDetailLoading: s.isLoading
        };
    }), selectedPortfolioDetail = ref3.selectedPortfolioDetail, isPortfolioDetailLoading = ref3.isPortfolioDetailLoading;
    var isCompanyLoading = (0,useEmittenInfoStore/* default */.Z)(function(s) {
        return s.isLoading;
    });
    var ref4 = selectedPortfolioDetail || {}, amountInvested = ref4.amount_invested, availableShare = ref4.available_share, exerciseData = ref4.exercise_data, bond = ref4.bond, info = ref4.info;
    var equity = (portfolioData || {}).equity;
    var portfolioDataSource = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "invested-label",
                children: "Invested"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "invested-content",
                children: amountInvested
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "exercise-price-label",
                children: "Exercise Price"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "exercise-price-content",
                children: (0,number/* formatNumber */.uf)(exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.price, true, "0,0.00")
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "shares-label",
                children: "Shares"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "shares-content",
                children: availableShare
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "maturity-label",
                children: "Bond Maturity"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "maturity-content",
                children: bond === null || bond === void 0 ? void 0 : bond.maturity
            })
        }, 
    ];
    var bondDataSource = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "rate-year-label",
                children: "Coupon Rate / Year"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "rate-year-content",
                children: bond === null || bond === void 0 ? void 0 : (ref = bond.coupon) === null || ref === void 0 ? void 0 : ref.year_rate
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "payment-date-label",
                children: "Coupon Payment Date"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "payment-date-content",
                children: bond === null || bond === void 0 ? void 0 : (ref1 = bond.coupon) === null || ref1 === void 0 ? void 0 : ref1.payment_date
            })
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "distribution-label",
                children: "Coupon Distribution"
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                "data-cy": "distribution-content",
                children: bond === null || bond === void 0 ? void 0 : (ref2 = bond.coupon) === null || ref2 === void 0 ? void 0 : ref2.distribution
            })
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 296
                }),
                loading: isPortfolioDetailLoading || isCompanyLoading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioInfoTable */.Tm, {
                        dataSource: portfolioDataSource
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioInfoTable */.Tm, {
                        dataSource: bondDataSource
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 56
                }),
                loading: isPortfolioDetailLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_PortfolioAllocation, {
                    unrealisedMarketValue: amountInvested,
                    equity: equity
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                style: {
                    backgroundColor: "#f2f1fe",
                    padding: "10px",
                    marginBottom: "30px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/info.svg",
                        width: "10px",
                        height: "10px",
                        style: {
                            margin: "4px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "13px",
                        children: info === null || info === void 0 ? void 0 : info[0]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                height: "45px",
                type: "outline-primary",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingSupport/* default */.Z, {}),
                onClick: crisp/* handleClickSupport */.lA,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "inherit",
                    weight: 600,
                    children: "Hubungi Support"
                })
            })
        ]
    });
};
/* harmony default export */ var ModalDetailStockBond = (ModalDetailStockBond_ModalDetail);

// EXTERNAL MODULE: ./src/features/securities/styled.ts
var securities_styled = __webpack_require__(38639);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./src/features/trade/components/Portfolio/PnLCurrency.tsx
var PnLCurrency = __webpack_require__(32978);
;// CONCATENATED MODULE: ./src/features/trade/components/Portfolio/BondModalDetail.tsx



function BondModalDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              margin: 2px;\n            "
    ]);
    BondModalDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






















function BondModalDetail(param) {
    var symbol = param.symbol, onCouponHistoryClick = param.onCouponHistoryClick;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return [
            s.detailBySymbol,
            s.isLoading,
            s.loadPortfolioDetails,
            s.couponHistories,
            s.product, 
        ];
    }, shallow/* default */.Z), 5), details = ref8[0], isLoading = ref8[1], loadPortfolioDetails = ref8[2], couponHistories = ref8[3], product = ref8[4];
    var handleCouponReceiptClick = function() {
        onCouponHistoryClick();
    };
    // merge histories
    var histories = (couponHistories === null || couponHistories === void 0 ? void 0 : (ref = couponHistories.histories) === null || ref === void 0 ? void 0 : ref.flatMap(function(history) {
        return history.items;
    })) || [];
    if (histories.length > 2) {
        histories = histories.slice(0, 2);
    }
    (0,react.useEffect)(function() {
        loadPortfolioDetails(symbol, true);
    }, [
        symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 64
                }),
                loading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* BorderedContainer */.a$, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                            align: "center",
                            justify: "space-between",
                            pb: "4px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(securities_styled/* Flex */.kC, {
                                    align: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        "data-cy": "bond-invested-label",
                                        children: "Total Modal Investasi"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-invested-content",
                                    children: (0,utils/* formatBondCurrency */.uJ)(details === null || details === void 0 ? void 0 : details.total_portfolio)
                                })
                            ]
                        }),
                        (details === null || details === void 0 ? void 0 : details.seller_coupon) > 0 && // @ts-expect-error
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                            align: "center",
                            justify: "space-between",
                            pb: "4px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            "data-cy": "bond-invested-label",
                                            children: "Kupon Penjual\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: InfoSvg/* default */.Z,
                                            style: {
                                                color: "#969696"
                                            },
                                            onClick: function() {
                                                return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-invested-content",
                                    children: (0,utils/* formatBondCurrency */.uJ)(details === null || details === void 0 ? void 0 : details.seller_coupon)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BondModalDetail_StyledDivider, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
                            header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                align: "center",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(securities_styled/* Flex */.kC, {
                                        direction: "column",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(securities_styled/* Flex */.kC, {
                                            align: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                "data-cy": "bond-pl-label",
                                                mr: "4px",
                                                children: "P&L (Unrealized)"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                        dataCy: "bond-pl-content",
                                        amount: details === null || details === void 0 ? void 0 : details.profit_loss.amount,
                                        percentage: details === null || details === void 0 ? void 0 : details.profit_loss.percentage
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                        align: "center",
                                        justify: "space-between",
                                        py: "8px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        "data-cy": "bond-accrued-interest-label",
                                                        mr: "4px",
                                                        children: "Kupon Berjalan"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        component: InfoSvg/* default */.Z,
                                                        style: {
                                                            color: "#969696"
                                                        },
                                                        onClick: function() {
                                                            return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                dataCy: "bond-accrued-interest-content",
                                                amount: details === null || details === void 0 ? void 0 : details.accrued_interest
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                        align: "center",
                                        justify: "space-between",
                                        py: "8px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        "data-cy": "bond-capital-gain-loss-label",
                                                        mr: "4px",
                                                        children: "Capital Gain / Loss"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        component: InfoSvg/* default */.Z,
                                                        style: {
                                                            color: "#969696"
                                                        },
                                                        onClick: function() {
                                                            return openInfoModal(constants/* BondInfoType.CAPITAL_GAIN_LOSS */.Im.CAPITAL_GAIN_LOSS);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                dataCy: "bond-capital-gain-loss-content",
                                                amount: details === null || details === void 0 ? void 0 : details.capital_gain_loss.amount,
                                                percentage: details === null || details === void 0 ? void 0 : details.capital_gain_loss.percentage
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 55
                }),
                loading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* BorderedContainer */.a$, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
                        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                            align: "center",
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                    direction: "column",
                                    align: "start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(securities_styled/* Flex */.kC, {
                                            align: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                "data-cy": "bond-total-pl-label",
                                                mr: "4px",
                                                children: "Total Keuntungan"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "12px",
                                            color: "#B5B5B5",
                                            children: "Selama Investasi"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                    dataCy: "bond-total-pl-content",
                                    amount: details === null || details === void 0 ? void 0 : (ref1 = details.total_profit_loss) === null || ref1 === void 0 ? void 0 : ref1.amount,
                                    percentage: details === null || details === void 0 ? void 0 : (ref2 = details.total_profit_loss) === null || ref2 === void 0 ? void 0 : ref2.percentage
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                    align: "center",
                                    justify: "space-between",
                                    py: "8px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    "data-cy": "bond-daily-accrued-interest-label",
                                                    mr: "4px",
                                                    children: "Total Kupon Harian"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        color: "#969696"
                                                    },
                                                    onClick: function() {
                                                        return openInfoModal(constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                            dataCy: "bond-daily-accrued-interest-content",
                                            amount: details === null || details === void 0 ? void 0 : details.daily_accrued_interest.amount,
                                            percentage: details === null || details === void 0 ? void 0 : details.daily_accrued_interest.percentage
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                    align: "center",
                                    justify: "space-between",
                                    py: "8px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    "data-cy": "bond-capital-gain-loss-2-label",
                                                    mr: "4px",
                                                    children: "Capital Gain / Loss"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        color: "#969696"
                                                    },
                                                    onClick: function() {
                                                        return openInfoModal(constants/* BondInfoType.CAPITAL_GAIN_LOSS */.Im.CAPITAL_GAIN_LOSS);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                            dataCy: "bond-capital-gain-loss-2-content",
                                            amount: details === null || details === void 0 ? void 0 : details.capital_gain_loss.amount,
                                            percentage: details === null || details === void 0 ? void 0 : details.capital_gain_loss.percentage
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 129
                }),
                loading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                    dataSource: [
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        "data-cy": "bond-total-units-label",
                                        mr: "4px",
                                        children: "Total Unit Obligasi"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            color: "#969696"
                                        },
                                        onClick: function() {
                                            return openInfoModal(constants/* BondInfoType.TOTAL_UNIT */.Im.TOTAL_UNIT);
                                        }
                                    })
                                ]
                            }),
                            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-total-units-content",
                                children: details === null || details === void 0 ? void 0 : details.total_units
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-average-price-label",
                                children: "Harga Beli Rata-rata"
                            }),
                            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                dataCy: "bond-average-price-content",
                                amount: details === null || details === void 0 ? void 0 : details.price_rate,
                                isFillEmptyWithDash: true,
                                isColorless: true,
                                isSignless: true,
                                isOnlyPercentage: true
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-yield-rate-label",
                                children: "Yield Rata-rata"
                            }),
                            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-yield-rate-content",
                                children: (0,number/* formatPercentage */.rl)(details === null || details === void 0 ? void 0 : details.yield_rate, false, "0,0.000", true)
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-due-date-label",
                                children: "Jatuh Tempo"
                            }),
                            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-due-date-content",
                                children: (0,utils/* formatBondDate */.qF)(product === null || product === void 0 ? void 0 : (ref3 = product.meta) === null || ref3 === void 0 ? void 0 : ref3.maturity_date)
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        "data-cy": "bond-projected-return-label",
                                        mr: "4px",
                                        children: "Proyeksi Return"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            color: "#969696"
                                        },
                                        onClick: function() {
                                            return openInfoModal(constants/* BondInfoType.PROJECTED_RETURN */.Im.PROJECTED_RETURN);
                                        }
                                    })
                                ]
                            }),
                            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                dataCy: "bond-projected-return-content",
                                amount: details === null || details === void 0 ? void 0 : (ref4 = details.projected_return) === null || ref4 === void 0 ? void 0 : ref4.amount,
                                percentage: details === null || details === void 0 ? void 0 : (ref5 = details.projected_return) === null || ref5 === void 0 ? void 0 : ref5.percentage,
                                isFillEmptyWithDash: true
                            })
                        }, 
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 129
                }),
                loading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                    dataSource: [
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-per-year-label",
                                children: "Kupon / Tahun"
                            }),
                            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-per-year-content",
                                children: (0,number/* formatPercentage */.rl)(product === null || product === void 0 ? void 0 : (ref6 = product.meta) === null || ref6 === void 0 ? void 0 : ref6.coupon_rate, false, "0,0.000", false)
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-next-date-label",
                                children: "Tanggal Kupon Berikutnya"
                            }),
                            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                "data-cy": "bond-next-date-content",
                                children: (0,utils/* formatBondDate */.qF)(product === null || product === void 0 ? void 0 : (ref7 = product.meta) === null || ref7 === void 0 ? void 0 : ref7.next_coupon_date)
                            })
                        }, 
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* PortfolioSkeletonBlock */.Kg, {
                    height: 111
                }),
                loading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_styled/* SectionButton */.M9, {
                    "data-cy": "transaction-history-button",
                    className: "button-unstyled full-button",
                    onClick: handleCouponReceiptClick,
                    type: "button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                        dataSource: (histories === null || histories === void 0 ? void 0 : histories.length) > 0 ? [
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-receipt-history-label",
                                    family: "bold",
                                    // @ts-expect-error
                                    mr: "4px",
                                    children: "Riwayat Penerimaan Kupon"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    component: Icons/* ChevronRightSvg */.dj
                                })
                            }, 
                        ].concat((0,_to_consumable_array/* default */.Z)(histories.map(function(history) {
                            return {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-history-date-label",
                                    children: (0,utils/* formatBondDate */.qF)(history.date)
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-history-amount-content",
                                    children: (0,utils/* formatBondCurrency */.uJ)(history.amount)
                                })
                            };
                        }))) : []
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_ToHistoryButton, {
                symbol: symbol
            })
        ]
    });
}
/* harmony default export */ var Portfolio_BondModalDetail = (BondModalDetail);
var BondModalDetail_StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-6be5cf65-0"
})(BondModalDetail_templateObject());

// EXTERNAL MODULE: ./src/features/trade/components/styled.ts
var components_styled = __webpack_require__(94514);
;// CONCATENATED MODULE: ./src/features/trade/components/Portfolio/PortoDetailModal.tsx

































var PortoDetailModal_MODAL_TYPES = {
    detail: "detail",
    exercise: trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE,
    sell: trading/* ORDER_TYPE.SELL */.Jm.SELL,
    history: "history",
    tnc: types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC,
    autoorder: "auto-order",
    bondCouponHistory: constants/* BondsModalTypeEnum.COUPON_RECEIPT */._y.COUPON_RECEIPT
};
var PortoDetailModal = function(param) {
    var visible = param.visible, symbol = param.symbol, isDayTrade = param.isDayTrade, exerciseable = param.exerciseable, type = param.type, onCancel = param.onCancel, _initialModalType = param.initialModalType, initialModalType = _initialModalType === void 0 ? PortoDetailModal_MODAL_TYPES.detail : _initialModalType, initialAutoOrderType = param.initialAutoOrderType;
    var isVirtualTrading = (0,useTradingAccount/* default */.Z)().isVirtualTrading;
    var ref = (0,tradingData/* default */.Z)(function(s) {
        var ref, ref1;
        var selectedData = isDayTrade ? (ref = s.portfolio.data) === null || ref === void 0 ? void 0 : ref.day_trade : (ref1 = s.portfolio.data) === null || ref1 === void 0 ? void 0 : ref1.result;
        var ref2;
        var portfolioItem = (ref2 = selectedData === null || selectedData === void 0 ? void 0 : selectedData.find(function(item) {
            return item.symbol === symbol;
        })) !== null && ref2 !== void 0 ? ref2 : {};
        return {
            allowOrder: portfolioItem.allow_order,
            portfolioType: portfolioItem.type,
            canSell: portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.can_sell
        };
    }, shallow/* default */.Z), allowOrder = ref.allowOrder, portfolioType = ref.portfolioType, canSell = ref.canSell;
    var ref1 = (0,store/* default */.Z)(function(s) {
        return {
            tradingModalVisible: s.visible,
            showTradingModal: s.showModal
        };
    }, shallow/* default */.Z), tradingModalVisible = ref1.tradingModalVisible, showTradingModal = ref1.showTradingModal;
    var globalActiveModal = (0,useGlobalModalStore/* default */.Z)(function(s) {
        return s.activeModal;
    });
    var ref2 = (0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return {
            portfolioDetail: s.data,
            portfolioDetailDayTrade: s.dayTrade,
            isLoading: s.isLoading,
            loadPortfolioDetail: s.loadPortfolioDetail
        };
    }, shallow/* default */.Z), portfolioDetail = ref2.portfolioDetail, portfolioDetailDayTrade = ref2.portfolioDetailDayTrade, loadPortfolioDetail = ref2.loadPortfolioDetail;
    var ref3 = (0,useEmittenInfoStore/* default */.Z)(function(s) {
        var ref;
        return {
            typeCompany: (ref = s.data.type_company) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            orderbook: s.data.orderbook
        };
    }, shallow/* default */.Z), typeCompany = ref3.typeCompany, orderbook = ref3.orderbook;
    var ref4 = (0,react.useState)(initialModalType), modalType = ref4[0], setModalType = ref4[1];
    var selectedPortfolioDetail = isDayTrade ? portfolioDetailDayTrade : portfolioDetail;
    var ref5 = selectedPortfolioDetail !== null && selectedPortfolioDetail !== void 0 ? selectedPortfolioDetail : {}, available_lot = ref5.available_lot, unrealised_gain = ref5.unrealised_gain, detailSymbol = ref5.symbol, companyName = ref5.company_name;
    var isAllowOrder = allowOrder === 1;
    var isKEF01CB = symbol === "KAEF01CB";
    var isBond = type === trading/* STOCK_TYPE.bond */.L2.bond;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return [
            s.detailBySymbol,
            s.product, 
        ];
    }), 2), bondDetails = ref6[0], bondProduct = ref6[1];
    var openBondSellModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openSellModal;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var handleTradeExerciseClick = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            setModalType(trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE);
            (0,securities/* clevertapPortfolioDetailExercise */.Lx)(symbol);
        });
    };
    var handleTradeSellClick = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            setModalType(trading/* ORDER_TYPE.SELL */.Jm.SELL);
            var TYPE = isVirtualTrading ? virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading : virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading;
            (0,clevertap/* clevertapEvent */.Lq)("Sell Order Viewed", {
                Symbol: symbol,
                Type: TYPE
            });
            (0,securities/* clevertapPortfolioSell */.mD)({
                tradingType: TYPE,
                symbol: symbol,
                source: "Portfolio Stock Detail Page",
                gainLoss: parseFloat(String(unrealised_gain)).toFixed(4)
            });
        });
    };
    var handleTradeBondSellClick = function() {
        openBondSellModal(symbol, undefined, "Portfolio Detail");
        FRBondActionTrackers.onOrderButtonClicked("Sell", symbol, "Portfolio Detail");
        onCancel();
    };
    (0,react.useEffect)(function() {
        if ([
            trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE,
            trading/* ORDER_TYPE.SELL */.Jm.SELL
        ].includes(modalType) && orderbook) {
            showTradingModal({
                symbol: symbol,
                orderType: modalType,
                orderedLot: Math.floor(available_lot)
            });
        }
    }, [
        modalType
    ]);
    (0,react.useEffect)(function() {
        if (!tradingModalVisible && !globalActiveModal) {
            setModalType(PortoDetailModal_MODAL_TYPES.detail);
        }
    }, [
        tradingModalVisible,
        globalActiveModal
    ]);
    (0,react.useEffect)(function() {
        if (unrealised_gain && symbol === detailSymbol) {
            (0,securities/* clevertapPortfolioDetailViewed */.qj)({
                symbol: symbol,
                gainLoss: unrealised_gain * 100,
                exerciseable: exerciseable,
                dayTrade: isDayTrade
            });
        }
    }, [
        unrealised_gain,
        detailSymbol
    ]);
    (0,react.useEffect)(function() {
        if (!globalActiveModal) loadPortfolioDetail(symbol).catch(onCancel);
    }, [
        symbol,
        globalActiveModal
    ]);
    (0,react.useEffect)(function() {
        setModalType(initialModalType);
    }, [
        initialModalType
    ]);
    var ref7;
    var footerButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styled/* ModalButtonContainerSecondary */.c7, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: exerciseable,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTable_styled/* DetailOrderButton */.VT, {
                    variant: "amend",
                    className: "exercise",
                    onClick: handleTradeExerciseClick,
                    children: "Exercise"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isAllowOrder && canSell && !isBond,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTable_styled/* DetailOrderButton */.VT, {
                    variant: "cancel",
                    disabled: !canSell,
                    onClick: handleTradeSellClick,
                    children: "Sell"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isBond && (bondDetails === null || bondDetails === void 0 ? void 0 : bondDetails.invested_amount) > 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTable_styled/* DetailOrderButton */.VT, {
                    variant: "cancel",
                    disabled: Number((ref7 = bondDetails === null || bondDetails === void 0 ? void 0 : bondDetails.units) !== null && ref7 !== void 0 ? ref7 : 0) === 0,
                    onClick: handleTradeBondSellClick,
                    onClickCapture: function() {
                        FRBondActionTrackers.onOrderButtonClicked("Sell", symbol, "Portfolio Page", (0,number/* formatNumber */.uf)(bondDetails === null || bondDetails === void 0 ? void 0 : bondDetails.yield_rate, false, "0,0.00"));
                    },
                    children: "Sell"
                })
            })
        ]
    });
    var ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modalType === PortoDetailModal_MODAL_TYPES.bondCouponHistory,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondCouponReceipt, {
                    isVisible: modalType === PortoDetailModal_MODAL_TYPES.bondCouponHistory,
                    onCancel: function() {
                        return setModalType(PortoDetailModal_MODAL_TYPES.detail);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modalType === PortoDetailModal_MODAL_TYPES.detail,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal/* default */.Z, {
                    visible: visible,
                    onCancel: onCancel,
                    title: "Portfolio Detail",
                    symbol: symbol,
                    showPrice: false,
                    isBonds: isBond,
                    bondsName: (ref8 = bondProduct === null || bondProduct === void 0 ? void 0 : bondProduct.label) !== null && ref8 !== void 0 ? ref8 : companyName,
                    showBondPrice: !isKEF01CB,
                    suffix: footerButton,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: isBond && !isKEF01CB,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_BondModalDetail, {
                                symbol: symbol,
                                onCouponHistoryClick: function() {
                                    setModalType(PortoDetailModal_MODAL_TYPES.bondCouponHistory);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: isBond && isKEF01CB,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetailStockBond, {
                                symbol: symbol
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: !isBond,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Portfolio_ModalDetail, {
                                symbol: symbol,
                                stockType: typeCompany,
                                isDayTrade: isDayTrade,
                                onAutoOrderClick: setModalType
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modalType === PortoDetailModal_MODAL_TYPES.history,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(History_SymbolHistoryModal, {
                    visible: modalType === PortoDetailModal_MODAL_TYPES.history,
                    symbol: symbol,
                    stockType: portfolioType !== null && portfolioType !== void 0 ? portfolioType : type,
                    onCancel: onCancel
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(provider/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: modalType === PortoDetailModal_MODAL_TYPES.autoorder,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoOrder/* default */.Z, {
                            visible: modalType === PortoDetailModal_MODAL_TYPES.autoorder,
                            symbol: symbol,
                            onCancel: onCancel,
                            initialType: initialAutoOrderType
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: modalType === PortoDetailModal_MODAL_TYPES.tnc,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoOrderTnc, {
                            visible: modalType === PortoDetailModal_MODAL_TYPES.tnc,
                            onSubmit: function() {
                                return setModalType(PortoDetailModal_MODAL_TYPES.autoorder);
                            },
                            onCancel: function() {
                                return setModalType(PortoDetailModal_MODAL_TYPES.detail);
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Portfolio_PortoDetailModal = (PortoDetailModal);


/***/ }),

/***/ 62469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DX": function() { return /* binding */ CustomText; },
/* harmony export */   "Kg": function() { return /* binding */ PortfolioSkeletonBlock; },
/* harmony export */   "M9": function() { return /* binding */ SectionButton; },
/* harmony export */   "Tm": function() { return /* binding */ PortfolioInfoTable; },
/* harmony export */   "gO": function() { return /* binding */ TableContent; },
/* harmony export */   "m8": function() { return /* binding */ OrdersTable; },
/* harmony export */   "x3": function() { return /* binding */ PortfolioActionMenu; },
/* harmony export */   "xD": function() { return /* binding */ TableHeader; },
/* harmony export */   "y6": function() { return /* binding */ TableWrapper; },
/* harmony export */   "yu": function() { return /* binding */ OrderRow; }
/* harmony export */ });
/* unused harmony exports SectionWrapper, Select */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8089);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41080);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48308);
/* harmony import */ var _deprecated_ui_widget_Select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48469);
/* harmony import */ var _DetailModal_InfoTable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51981);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-dropdown-menu-item-disabled {\n    cursor: not-allowed;\n    &:hover {\n      background-color: #ffffff;\n      color: rgba(0, 0, 0, 0.25);\n      cursor: not-allowed;\n    }\n  }\n\n  & > .ant-menu-item-selected {\n    background-color: #ffffff !important;\n    color: #333333;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n\n  & > .ant-skeleton-button {\n    border-radius: 4px;\n    height: ",
        ";\n    width: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border-radius: 4px;\n  border-bottom-right-radius: none;\n  border-bottom-left-radius: none;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 0;\n  height: auto;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  border-top: 1px solid ",
        ";\n  font-size: 12px;\n\n  ",
        " {\n    font-weight: 700;\n    color: #858585;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 0px;\n\n  &.buy,\n  &.open,\n  &.active,\n  &.ready,\n  &.partial,\n  &.verified,\n  &.submitted,\n  &.success,\n  &.pending,\n  &.request_amend {\n    color: ",
        ";\n  }\n\n  &.sell,\n  &.rejected {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 160px;\n  overflow: auto;\n\n  &.history {\n    max-height: 320;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  padding: 0 16px;\n  margin: 0;\n  height: 32px;\n  flex-wrap: nowrap;\n  gap: 16px;\n  color: ",
        ";\n  font-size: 12px;\n  background: transparent;\n  border: none;\n  text-align: left;\n  width: 100%;\n\n  &:not(:disabled) {\n    cursor: pointer;\n    &:hover {\n      background: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-selector {\n    border-radius: 16px !important;\n  }\n\n  .ant-select-selector {\n    .ant-select-selection-item {\n      .select-label {\n        color: ",
        ";\n        font-family: var(--font-regular);\n        display: inline;\n        margin: 0;\n        background: transparent;\n        padding: 0;\n        font-size: 12px;\n      }\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}







// @ts-expect-error
var Menu = _deprecated_ui_common_Dropdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Menu */ .ZP.Menu;
var SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-65a3da00-0"
})(_templateObject());
var SectionButton = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.attrs */ .ZP.button.attrs({
    className: "button-unstyled full-button"
}).withConfig({
    componentId: "sc-65a3da00-1"
})(_templateObject1());
var PortfolioInfoTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_DetailModal_InfoTable__WEBPACK_IMPORTED_MODULE_5__/* .InfoTable */ .C).withConfig({
    componentId: "sc-65a3da00-2"
})(_templateObject2());
var PortfolioActionMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(Menu).withConfig({
    componentId: "sc-65a3da00-3"
})(_templateObject3());
var PortfolioSkeletonBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Button */ .Z.Button).attrs({
    active: true
}).withConfig({
    componentId: "sc-65a3da00-4"
})(_templateObject4(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var TableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-65a3da00-5"
})(_templateObject5());
var TableContent = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-65a3da00-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].downgray */ .Z.downgray);
var TableHeader = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-65a3da00-7"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_common__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv);
var CustomText = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-65a3da00-8"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var OrdersTable = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-65a3da00-9"
})(_templateObject9());
var OrderRow = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-65a3da00-10"
})(_templateObject10(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].component */ .Z.component);
var Select = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_widget_Select__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-65a3da00-11"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].nightRider */ .Z.nightRider);


/***/ })

}]);